import { render, staticRenderFns } from "./BusinessProcessAppoint.vue?vue&type=template&id=14f36e16&scoped=true&"
import script from "./BusinessProcessAppoint.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessAppoint.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcessAppoint.vue?vue&type=style&index=0&id=14f36e16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f36e16",
  null
  
)

export default component.exports